import { Button } from 'shared/components/ui';
import React, { useRef } from 'react';

import { Add } from '@mui/icons-material';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import useCalendario from '../hooks/useCalendario';

const CalendarioView = ({ onNuevoHorarioMedico, onEditarHorario }) => {
  const calendarRef = useRef(null);
  const { eventos, fetchEventos, crearNota, eliminarNota } = useCalendario();

  const handleEventClick = (info) => {
    const evento = info.event;
    
    if (evento.extendedProps.type === 'Nota') {
      if (window.confirm('¿Desea eliminar esta nota?')) {
        eliminarNota(evento.id);
      }
    } else if (evento.extendedProps.type === 'HorarioMedico') {
      onEditarHorario({ idHorarioMedico: evento.extendedProps.idHorarioMedico });
    } else {
      onEditarHorario({ id: evento.id });
    }
  };

  const handleSelect = (info) => {
    const note = prompt('Agrega una nota:');
    if (note) {
      crearNota(info.start, info.end, note);
    }
    calendarRef.current?.getApi()?.unselect();
  };

  const handleDatesSet = (dateInfo) => {
    fetchEventos(dateInfo.start, dateInfo.end);
  };

  return (
    <div className="calendario-view">
      <div className="calendario-actions">
        <Button
          variant="success" 
          size="sm" 
          onClick={onNuevoHorarioMedico}
          className="btn-new-horario"
        >
          <Add sx={{ fontSize: 18, mr: 0.5 }} />
          Nuevo Horario Médico
        </Button>
      </div>

      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        locale={esLocale}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        buttonText={{
          today: 'Hoy',
          month: 'Mes',
          week: 'Semana',
          day: 'Día'
        }}
        allDayText="Hora"
        selectable={true}
        events={eventos}
        eventClick={handleEventClick}
        select={handleSelect}
        datesSet={handleDatesSet}
        height="auto"
        slotMinTime="06:00:00"
        slotMaxTime="22:00:00"
      />
    </div>
  );
};

export default CalendarioView;
